<template>
	<div>
		<div>
			<div class="li1" v-for="(item, index) in list" :key="index">
				<div v-if="item.status === 2">
					<div class="node node1">{{ item.JX_Content }}</div>
					<div class="borderLeft borderLeft1"></div>
				</div>
				<div v-else>
					<div class="node">{{ item.JX_Content }}</div>
					<div class="borderLeft"></div>
				</div>
				<div class="two">
					<div class="name">{{ item.ui_realName }}</div>
					<div class="time">{{ item.CreateTime }}</div>
				</div>
				<div class="advice">{{ item.advice }}</div>
			</div>
		</div>

		<el-empty v-if="list.length == 0" description="暂无考核动态"></el-empty>
	</div>
</template>

<script>
import { GetJxTrendslist } from '@/request/api/homesview/yunhomes/yunhom.js';
export default {
	data() {
		return {
			list: [
				{
					node: '报名',
					name: '张三',
					time: '12:00',
					status: 1,
					advice: ''
				},
				{
					node: '报名',
					name: '张三',
					time: '12:00',
					status: 1,
					advice: ''
				},
				{
					node: '报名',
					name: '小红',
					time: '12:00',
					status: 1,
					advice: ''
				},
				{
					node: '正常考核',
					name: '',
					time: '',
					status: 1,
					statusacs: 1,
					advice: ''
				},
				{
					node: '考核通过',
					name: '',
					time: '',
					status: 1,
					advice: ''
				}
			],
			pageIndex: 1,
			pageSize: 10,
			isids: '',
			totalCount: 0
		};
	},
	mounted() {
		if (this.$route.query) {
			this.isids = this.$route.query.id ?? '';
			this.getlist();
		} else {
			this.$router.back();
		}
	},
	methods: {
		getlist() {
			let isidsobj = {
				JX_GUID: this.isids,
				pageIndex: this.pageIndex,
				pageSize: this.pageSize
			};
			GetJxTrendslist(isidsobj).then(res => {
				this.list = res.data.data.list;
				this.totalCount = res.data.data.totalCount;
			});
		}
	}
};
</script>

<style scoped>
#app {
	margin-left: 8px;
}

.li1 {
	list-style: none;
	box-sizing: border-box;
	padding-left: 20px;
	position: relative;
}

.borderLeft {
	width: 2px;
	height: 100%;
	background-color: #00bc12;
	position: absolute;
	top: 11.225px;
	bottom: 0;
	left: -1px;
}

.borderLeft1 {
	background-color: #e6e6e6;
}

.node::before {
	z-index: 1;
	content: '';
	background-color: #00bc12;
	width: 20px;
	height: 20px;
	color: #fff;
	position: absolute;
	border-radius: 50%;
	left: 0;
	top: 11.225px;
	transform: translate(-50%, -50%);
}

.node {
	font-size: 16px;
	line-height: 22.5px;
	font-weight: 500;
	color: #00bc12;
}

.node1 {
	color: #ff3b30;
}

.node1::before {
	background-color: #ff3b30;
}

.node2 {
	color: #000;
}

.node2::before {
	background-color: #e6e6e6;
	width: 10px;
	height: 10px;
}

.name {
	width: 130px;
	padding: 10px 40px 20px 0;
	color: #333333;
}

.time {
	color: #666666;
	font-size: 15px;
}

.two {
	display: flex;
	align-items: baseline;
}

.advice {
	font-size: 14px;
	color: #999999;
	padding-bottom: 20px;
}

.li1:last-child .borderLeft {
	display: none;
}
</style>
